import { combineReducers } from 'redux';
import edi from './slices/edi.slice';

const reducer = combineReducers({
  edi
})

export default reducer;
